export default __webpack_public_path__ + "static/media/planet.a56b0ef5.svg";